const countryTimeZones = {
  CanadaAtlantic: 'Canada/Atlantic',
  AustraliaSydney: 'Australia/Sydney',
  USEastern: 'US/Eastern'
};

export default countryTimeZones;
